import { BP_PREMIUM_PRICE } from './battlepass.js';

// Ofertas da loja de donate (Noxara Coins). Preços são propostas iniciais para o Arthur aprovar.

export interface StoreOffer {
  id: string; name: string; price: number; desc: string;
  kind: 'vip' | 'exercise' | 'item' | 'bpass' | 'prey3' | 'preycards';
  days?: number;
  /** item de treino: prefixo do nome (o tipo é escolhido na compra) e cargas */
  prefix?: string; charges?: number;
  item?: string; count?: number;
  /** id do item mostrado como ícone */
  icon: number;
  /** imagem da interface do Tibia no lugar do item (ex.: ícone dos prey cards) */
  img?: string;
}

export const STORE_OFFERS: StoreOffer[] = [
  { id: 'bp-premium', name: 'Passe de batalha premium (mês atual)', price: BP_PREMIUM_PRICE, kind: 'bpass', icon: 22771,
    desc: 'Libera a trilha premium do passe deste mês, incluindo a recompensa final exclusiva da temporada.' },
  { id: 'vip7', name: 'VIP (7 dias)', price: 65, kind: 'vip', days: 7, icon: 14758,
    desc: '+30% de experiência, caça offline por mais horas, venda na hunt a cada 10 min, mais tentativas e entradas e as outras vantagens VIP. Soma ao VIP que você já tiver.' },
  { id: 'vip30', name: 'VIP (30 dias) — mais vantajoso', price: 250, kind: 'vip', days: 30, icon: 14758,
    desc: '+30% de experiência, caça offline por mais horas, venda na hunt a cada 10 min, mais tentativas e entradas e as outras vantagens VIP. Sai cerca de 10% mais barato por dia que o de 7 dias.' },
  { id: 'prey3', name: 'Terceiro espaço de prey (permanente)', price: 250, kind: 'prey3', icon: 22118, img: '/assets/interface/images/icon-prey-preycreature.png',
    desc: 'Libera para sempre o 3º espaço de prey deste personagem: mais uma criatura com bônus ao mesmo tempo.' },
  { id: 'preycards5', name: '5 Prey Cards', price: 25, kind: 'preycards', count: 5, icon: 22118, img: '/assets/interface/images/prey-wildcards-icon.png',
    desc: 'Cartas para trocar o bônus do prey (1 carta) ou escolher qualquer criatura (5 cartas).' },
  { id: 'rtoken1', name: '1 Ficha da Roleta', price: 25, kind: 'item', item: 'Ficha da Roleta', count: 1, icon: 19082,
    desc: 'Uma ficha para girar a Roleta. Fica na Noxara Store Box (ou na mochila) e é gasta ao girar.' },
  { id: 'rtoken10', name: '10 Fichas da Roleta', price: 225, kind: 'item', item: 'Ficha da Roleta', count: 10, icon: 19082,
    desc: 'Dez fichas para a Roleta (uma de graça). Ficam na Noxara Store Box (ou na mochila) e são gastas ao girar.' },
  { id: 'ex500', name: 'Exercise (500 usos)', price: 25, kind: 'exercise', prefix: 'exercise', charges: 500, icon: 28552,
    desc: 'Item de treino de skill para usar nos bonecos do templo (500 usos).' },
  { id: 'ex1800', name: 'Durable Exercise (1.800 usos)', price: 90, kind: 'exercise', prefix: 'durable exercise', charges: 1800, icon: 35279,
    desc: 'Item de treino de skill durável (1.800 usos).' },
  { id: 'ex14400', name: 'Lasting Exercise (14.400 usos)', price: 720, kind: 'exercise', prefix: 'lasting exercise', charges: 14400, icon: 35285,
    desc: 'Item de treino de skill de longa duração (14.400 usos).' },
];

export const EXERCISE_KINDS: Array<[string, string]> = [
  ['sword', 'Espada'], ['axe', 'Machado'], ['club', 'Clava'], ['bow', 'Arco'], ['rod', 'Rod'], ['wand', 'Wand'], ['wraps', 'Faixas (monk)'], ['shield', 'Escudo'],
];
